export default {
  invitations: [],
  invitationCount: 0,
  invitation: {},
  kioskInfo: {}
}